import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import { useUnhideReview } from '../model/use-unhide-review';
import { ReviewConflictNotice } from './review-conflict-notice';

interface UnhideReviewButtonProps {
  readonly review: { readonly id: string; readonly updatedAt: string };
}

/** 숨긴 후기를 다시 공개한다 — 그사이 후기가 바뀌었으면(충돌) 새로 불러오라고 알린다. */
export const UnhideReviewButton = ({ review }: UnhideReviewButtonProps): ReactElement => {
  const { unhide, isPending, error, isConflict, reset } = useUnhideReview();
  return (
    <div className="flex flex-col items-start gap-2">
      <Button
        type="button"
        variant="outline"
        isLoading={isPending}
        disabled={isPending}
        onClick={() => void unhide({ reviewId: review.id, expectedUpdatedAt: review.updatedAt })}
      >
        다시 공개
      </Button>
      {isConflict ? (
        <ReviewConflictNotice reviewId={review.id} onReloaded={reset} />
      ) : error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
};
